<template>
  <q-dialog ref="dialog" @hide="onDialogHide" persistent>
    <q-card class="q-dialog-plugin">
      <q-card-section>
            <div class="text-h6 ellipsis text-center">
              Are you still working?
          </div>
      </q-card-section>
      <q-card-section>
            <div class="row no-wrap justify-center">
              <q-circular-progress
                show-value
                font-size="12px"
                :value="progressPercentage"
                size="200px"
                :thickness="0.22"
                color="teal"
                track-color="grey-3"
                class="q-ma-md"
              >
              {{ progressValue }}
              </q-circular-progress>
          </div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn label="Not Working" @click="onCancelClick" />
        <q-btn color="primary" label="Working" @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    progressPercentage: Number,
    progressValue: [Number, String]
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok');
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    }
  }
};
</script>
